/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import _ from 'lodash';

import { _date } from '@mairistem/administres-utils';
import { Table } from '@mairistem/composants';

import type { Acte } from '@/types';
import { trimComma } from '@/utils';

interface Props {
  acte: Acte;
}

const ActeTableLineDeces = ({ acte }: Props) => {
  const dateDeces = `${_date.short(acte.dateDeces ?? '')} - ${_.padStart(acte.heureDeces, 2, '0')}:${_.padStart(acte.minuteDeces, 2, '0')}`;

  return (
    <>
      <Table.Cell content={dateDeces} />
      <Table.Cell content={trimComma(acte.nomClassementDefunt)} />
      <Table.Cell
        content={[acte.nomClassementPere, acte.nomClassementMere]
          .filter((v) => !_.isEmpty(v))
          .map(trimComma)
          .join(' - ')}
      />
    </>
  );
};

export default ActeTableLineDeces;
